import React, { useState, useContext, useEffect } from 'react'
import SideNav from '../shared/SideNav'
import Breadcrumb from '../../shared/Breadcrumb'
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Util from '../../../Util';
import { apiRoutes } from '../../../AppSettings';

const MyPatients = () => {
	const { userState } = useContext(AuthContext);
    const [doctor, setDoctor] = useState(userState.loggedInUser);
	const [patients, setPatients] = useState([]);
	const loggedInDoctorId = userState.user.userId;
	
	const updatePatients = (data) => {
		setPatients(data);
	} 

	useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer '+userState.token
            }
          };
        axios.get(apiRoutes.getPatients + loggedInDoctorId, options)
          .then((response) => {
            if(response.status === 200)
            {
				const data = response.data;
			    updatePatients(data.data);
            	console.log(data);
            }
          }, (error) => {
            console.log(error);
          });

    }, []);

    return ( 
        <div>
            <Breadcrumb title= "My Patients"/>
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
						    <SideNav applyCssFor = 'mypatients' user={doctor}/>
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="row row-grid">
								{
									patients.map(patient => (
										<div key={patient.patientId} className="col-md-6 col-lg-4 col-xl-3">
											<div className="card widget-profile pat-widget-profile">
												<div className="card-body">
													<div className="pro-widget-content">
														<div className="profile-info-widget">
															<Link className="booking-doc-img" to={
																		{
																			pathname:'/PatientProfile',
																			state: {
																				patientId: patient.patientId
																			}
																		}
															}>
																<img src={Util.loadImage(patient.profileImage)} alt="User Image" />
															</Link>
															<div className="profile-det-info">
																<h3>
																	<Link to={
																		{
																			pathname:'/PatientProfile',
																			state: {
																				patientId: patient.patientId
																			}
																		}
																	}>{patient.firstName} {patient.lastName}</Link>
																</h3>
																<div className="patient-details">
																	<h5><b>Patient ID :</b> {patient.patientNumber}</h5>
																	<h5 className="mb-0"><i className="fas fa-map-marker-alt"></i> {patient.state}, {patient.country}</h5>
																</div>
																<Link className="btn btn-white msg-btn" to={
																	{
																		pathname: `/chat`,
																		state: {
																			receiver: JSON.stringify(patient)
																		}
																	}
																}><i className="far fa-comment-alt"></i></Link>
															</div>
														</div>
													</div>
													<div className="patient-info">
														<ul>
															<li>Phone <span>{patient.phone}</span></li>
															<li>Age <span>{ Util.getAge(new Date(patient.dob), new Date())} Years, {patient.gender}</span></li>
															<li>Blood Group <span>{patient.bloodGroup}</span></li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									))	
								}
							</div>

						</div>
					</div>

				</div>

			</div>		
		</div>
     );
}
 
export default MyPatients;